package com.arena_web.pages

// TEMP-KEYBOARD-TEST page. DELETE BEFORE COMMIT.

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.arena_web.ui.components.overlay.BottomSheet
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Text

@Page("/kbtest")
@Composable
fun KbTestPage() {
    val open = remember { mutableStateOf(true) }

    Div(attrs = {
        style {
            property("min-height", "150vh")
            property("background", "#02040B")
            property("color", "#fff")
            property("padding", "20px")
            property("font-family", "sans-serif")
        }
    }) {
        Text("KB TEST PAGE")
        Button(attrs = { onClick { open.value = true } }) { Text("Open sheet") }
    }

    if (open.value) {
        BottomSheet(onDismiss = { open.value = false }) {
            Div(attrs = { style { property("color", "#fff"); property("font-size", "18px") } }) {
                Text("SHEET TOP")
            }
            Input(InputType.Text, attrs = {
                placeholder("top input")
                style {
                    property("height", "40px"); property("border-radius", "10px")
                    property("border", "1px solid #334"); property("background", "#1A2238")
                    property("color", "#fff"); property("padding", "0 10px")
                }
            })
            Div(attrs = {
                style {
                    property("height", "160px"); property("display", "flex")
                    property("align-items", "center"); property("justify-content", "center")
                    property("color", "#889")
                }
            }) { Text("middle filler") }
            Input(InputType.Text, attrs = {
                placeholder("bottom input")
                style {
                    property("height", "40px"); property("border-radius", "10px")
                    property("border", "1px solid #334"); property("background", "#1A2238")
                    property("color", "#fff"); property("padding", "0 10px")
                }
            })
            Div(attrs = {
                style {
                    property("height", "44px"); property("border-radius", "22px")
                    property("background", "#0061FF"); property("color", "#fff")
                    property("display", "flex"); property("align-items", "center")
                    property("justify-content", "center")
                }
            }) { Text("BOTTOM BUTTON") }
        }
    }
}
